import { useMemo } from 'react';
import { useLocation } from '@reach/router';
import { Locale } from '@contracts';
import { extractLanguageFromUrl } from './language';

export default function useCurrentURLLanguage(): Locale {
  const location = useLocation();
  const currentLanguage = useMemo(() => extractLanguageFromUrl(location.pathname), [location.pathname]);

  return currentLanguage;
}
